import {
	useCallback,
	useContext,
	useEffect,
	useRef,
	useState,
} from "react";
import { BlockBlobClient } from "@azure/storage-blob";
// import { sassFalse } from "sass";
import RebatesClient from "../../RebatesClient";
import { CustomDialog, Icon } from "../../components";
import {
	Alert,
	Box,
} from "@mui/material";

import { LoginContext } from "../../context/login-context";
import FarmSelector from "../../components/filters/farmSelector";

const CryptoJS = require("crypto-js");

const NO_FARM_UPLOAD_MESSAGE =
	"Invoices can only be uploaded to a Farm. Please create at least one Farm under the selected Account or Sub-Account before uploading invoices.";

const UploadModal = (props) => {
	const [loading, setLoading] = useState(false);
	const [title, setTitle] = useState(`Upload Invoice(s)`);

	const [errorFiles, setErrorFiles] = useState([]);
	const [drag, setDrag] = useState(false);
	const [dragCounter, setDragCounter] = useState(0);
	const inputRef = useRef(null);

	const { runProtected, state: userData } = useContext(LoginContext);

	const [selectedFarmAcctId, setSelectedFarmAcctId] = useState(null);

	const {
		open,
		setOpen,
		refetchInvoices,
		farms,
		farmsLoading,
		strategicAccounts,
		setSelectedInvoice,
		setShowInvoice,
	} = props;

	const hasNoFarms = !farmsLoading && (!farms || farms.length === 0);
	const canUpload = !hasNoFarms && !!selectedFarmAcctId;

	const handleSelectFarm = (farm) => {
		// console.log(farm)
		setSelectedFarmAcctId(farm?.id);
	}


	const farmSelect = (

		<FarmSelector
		farms={farms}
		strategicAccounts={strategicAccounts}
		// selectedFarms={selectedFarms}
		setSelectedFarms={handleSelectFarm}
		disabled={loading}
	/>

	)


	function rand(max) {
		return Math.floor(Math.random() * max);
	}

	const loadingSpinner =
		loading || errorFiles?.length > 0 ? (
			<Box sx={{ width: "100%" }}>
				<svg
					key={"svg-1"}
					width="352"
					height="100"
					viewBox="0 0 300 100"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					{Array.from({ length: 20 }, (_, i) => i).map((v, index) => {
						return (
							<svg
								key={"svg-outer" + index}
								viewBox={`${rand(
									index % 2 == 0 ? -300 : 300
								)} ${rand(-100)} ${rand(300)} ${rand(300)} `}
							>
								<path
									d="M11.9318 6.65909L9.09091 0.409088L6.25 6.65909L0 9.5L6.25 12.3409L9.09091 18.5909L11.9318 12.3409L18.1818 9.5L11.9318 6.65909Z"
									fill="#3ABDEE"
								>
									<animateMotion
										dur="10s"
										repeatCount="indefinite"
										path={`M${rand(
											index % 2 == 0 ? -20 : 20
										)},50 C20,-50 80,${rand(
											index % 2 == 0 ? -100 : 100
										)} ${rand(
											index % 2 == 0 ? -10 : -30
										)},50 C${rand(
											index % 2 == 0 ? -450 : 300
										)}-120 120,${rand(
											index % 2 == 0 ? -100 : 100
										)} 20,50 z`}
									/>

									{index % 4 == 0 && (
										<animateTransform
											attributeType="xml"
											attributeName="transform"
											type="rotate"
											from="360 8.4 9.5"
											to="0 8.4 9.5"
											dur="11.5s"
											additive="sum"
											repeatCount="indefinite"
										/>
									)}
								</path>

								<animate
									attributeName="viewBox"
									to={`${rand(
										index % 2 == 0 ? -300 : 300
									)} ${rand(-100)} ${rand(500)} ${rand(
										500
									)} `}
									dur="190s"
									repeatCount="indefinite"
								/>
							</svg>
						);
					})}
				</svg>
			</Box>
		) : null;

	const handleClick = () => {
		if(loading || !canUpload) return
		inputRef.current?.click()
	};

	const handleDragIn = (e) => {
		e.preventDefault();
		e.stopPropagation();
		if(loading || !canUpload) return
		let dc = { ...dragCounter };
		setDragCounter(dc--);
		if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
			setDrag(true);
		}
	};

	const handleDrag = (e) => {
		e.preventDefault();
		e.stopPropagation();
	};

	const handleDragOut = (e) => {
		e.preventDefault();
		e.stopPropagation();
		if(loading || !canUpload) return

		let dc = { ...dragCounter };
		dc--;
		setDragCounter(dc);
		if (dc === 0) {
			setDrag(false);
		}
	};
	const handleDrop = (e) => {
		e.preventDefault();
		e.stopPropagation();
		setDrag(false);
		setDragCounter(0);
		if(loading || !canUpload) return

		upload(e);
	};

	useEffect(() => {
		setDrag(false);
		setDragCounter(0);
		setErrorFiles([]);

		if (farms?.length === 1) {
			setSelectedFarmAcctId(farms[0].id);
		} else {
			setSelectedFarmAcctId(null);
		}
	}, [open]);

	async function getMd5Hash(file) {
		return new Promise((resolve, reject) => {
		  let reader = new FileReader();
	
		  reader.onload = () => {
			let binary = CryptoJS.lib.WordArray.create(reader.result)
			const md5 = CryptoJS.MD5(binary).toString(CryptoJS.enc.Base64)
			resolve(md5)
		  };
	
		  reader.onerror = reject;
		  reader.readAsArrayBuffer(file);
		})
	  }

	const upload = async (e) => {
		if (hasNoFarms || !selectedFarmAcctId) {
			return;
		}

		setLoading(true);
		setErrorFiles([]);

		var errs = [];
		const items = e?.dataTransfer?.items || e?.target.files;

		let webkitEntries = [];
		let fileToProcess = [];

		for (let i = 0; i < items.length; i++) {
			if (items?.[i]?.webkitGetAsEntry) {
				webkitEntries.push(items[i]?.webkitGetAsEntry());
			} else {
				webkitEntries.push(items[i]);
			}
		}

		while (webkitEntries.length > 0) {
			let entry = webkitEntries.shift();

			const isFile = entry.isFile || entry instanceof File;

			if (isFile) {
				const entryImgFile =
					entry instanceof File
						? entry
						: await new Promise((resolve, reject) => {
							entry.file(resolve, reject);
						});

				if (entryImgFile.name.charAt(0) === ".") {
					continue;
				}

				fileToProcess = [...fileToProcess, entryImgFile];
			}
		}

		if (fileToProcess.length === 0) {
			alert("No valid files found to upload.");
			setLoading(false);
			return;
		}

		let files = Array.from(fileToProcess);
		setTitle(`Uploading and Processing...`);

		var response;
		for (let index = 0; index < files.length; index++) {
			const file = files[index];

			let extension = "";
			if (file.type == "image/jpeg") {
				extension = "jpg";
			} else if (file.type == "application/pdf") {
				extension = "pdf";
			} else if (file.type == "image/png") {
				extension = "png";
			}

			try {

				const md5 = await getMd5Hash(file)

				let tokenResp = await RebatesClient.tokenForUpload(extension, md5);



				if (tokenResp?.response?.ok) {
					if (tokenResp?.body?.status == "DUPLICATE") {
						file.duplicate = true
						errs.push(file)
						continue
					}

					let blockBlobClient = new BlockBlobClient(
						`${tokenResp?.body?.signedTokenUrl}`
					);
					const options = {
						blobHTTPHeaders: { blobContentType: file.type },
					};


					const uploadResp = await blockBlobClient.uploadData(
						file,
						file.size,
						options
					);

					if (!uploadResp) {
						throw new Error(`Azure upload error`);
					}

					response = await RebatesClient.uploadComplete(
						tokenResp?.body?.url,
						selectedFarmAcctId,
						md5
					);

				}
			} catch (error) {
				console.log(error);
				errs.push(file);
			}
		}
		if (errs?.length == 0) {
			//todo would be better if use-invoices did upload so we could track state there when recieving new invoice here
			setSelectedInvoice({ ...response?.body, isNewUpload: true });
			setShowInvoice(true);
			refetchInvoices();
			setOpen(false);
			setTitle("Upload Invoice(s)");
		} else {
			console.log(errs)
			setTitle("Error Uploading");
			setErrorFiles(errs);
		}
		setLoading(false);
	};

	return (
		<CustomDialog
			open={open}
			onClose={(e, reason) => {
				if( !loading && reason !== "backdropClick" && reason !== "escapeKeyDown") {
					setOpen(false);
				}
				
			}}
			title={title}
			// dialogCss={css.dialog}
      style={{
		
        maxWidth: 400,
      }}
		>
			{/* <Box sx={{ flexGrow: 1 }}> */}
			{/* <Grid justifyContent="center" ref={dropRef} spacing={4} container > */}
			<div
				// ref={dropRef}
				onDragOver={handleDrag}
				onDrop={handleDrop}
				onDragEnter={handleDragIn}
				onDragLeave={handleDragOut}
				style={{
					cursor: loading || !canUpload ? '': 'pointer',
          display: 'flex',
          flexDirection: "column",
          alignItems: 'flex-start',
          justifyContent: 'flex-start',
          gap: 20,
					position: "relative",
					height: "100%",
					width: "100%",
				}}
			>
				{/* <Grid alignContent={'start'} xs={12}> */}
				{!hasNoFarms && farmSelect}
				{hasNoFarms && (
					<Alert severity="warning" sx={{ width: "100%" }}>
						{NO_FARM_UPLOAD_MESSAGE}
					</Alert>
				)}
				{/* </Grid> */}

        {!hasNoFarms && (loading || errorFiles?.length > 0) && (
          <div>
            {loadingSpinner}

            {errorFiles?.length > 0 && (
              <>
                <div>Error uploading:</div>

                {errorFiles?.map((file) => (
					<>
					{file?.duplicate && <div style={{ color: 'red' }}>{`Duplicate ${file?.type?.split('/')[1] ||''}:`}</div>}
				
					{file?.name}
					</>
			 	 )
			  )}
            </>
			)}

          </div>
        )}

				{!hasNoFarms && selectedFarmAcctId && !loading && (
					<div 
					onClick={ handleClick}
					style={{
            backgroundColor: 'white',
            border: '2px solid #3788BE',
            borderRadius: 12,
            padding: '16px 24px',
            width: '100%',
            display: 'flex',
            flexFlow: 'column nowrap',
            alignItems: 'center',
            justifyContent: 'flex-start',
            gap: 12,
          }}>
						<input
							disabled={loading || errorFiles?.length}
							type="file"
							style={{ display: "none" }}
							id="file"
							ref={inputRef}
							onChange={handleDrop}
							multiple
						/>

						<div style={{
              borderRadius: 8,
              backgroundColor: '#fff',
              border: '1px solid #E4E7EC',
              boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
              padding: 10,
            }}>
							<Icon icon="Upload" />
						</div>

						{!loading && (
							<div style={{
                color: '#475467',
                fontSize: 14,
                fontWeight: 400,
                lineHeight: '20px',
              }}><u>Upload</u> or drop file </div>
						)}

						{drag && (
							<div
								style={{
									border: "dashed #24ABFF 2px",
									backgroundColor: "rgba(255,255,255,.8)",
									position: "absolute",
									top: 0,
									bottom: 0,
									left: 0,
									right: 0,
									zIndex: 9999,
								}}
							>
								<div
									style={{
										position: "absolute",
										top: "50%",
										right: 0,
										left: 0,
										textAlign: "center",
										color: "grey",
										fontSize: 36,
									}}
								/>
							</div>
						)}
					</div>
				)}
			</div>
			{/* </Grid> */}
			{/* </Box> */}
		</CustomDialog>
	);
};

export default UploadModal;
